
<template>
    <flex-element
        v-if="coordinates"
        v-plaintext
        :element-type="elementType"
        :style="buttonStyle"
        @click.native="showOnMap"
    >
        <span :style="textStyle">
            {{ singleLineText }}
        </span>
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import { AShowOnMap } from '@/data/data-models';

export default {
    name: 'a-google-map-show-on-map',
    mixins: [baseAtom],

    props: {
        coordinates: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: 'button',
        },

        singleLineText: {
            type: String,
            default: 'Show on Map',
        },
    },

    data() {
        return {
            containerClassGroups: ['flexDirection'],
        };
    },

    computed: {
        renderType() {
            return this.typeNew || this.typeDefault;
        },

        buttonStyle() {
            return {
                pointerEvents: this.isLoading ? 'none' : 'auto',
            };
        },

        textStyle() {
            return {
                visibility: this.isLoading ? 'hidden' : 'visible',
            };
        },

        updatedElement() {
            return new AShowOnMap({
                ...this.updatedBaseElement,
                singleLineText: this.singleLineTextNew,
                type: this.typeNew,
                coordinates: this.coordinates,
            });
        },
    },

    methods: {
        showOnMap() {
            if (this.coordinates) {
                this.$root.$emit('flex::google-map::showOnMap', this.coordinates);
            }
        },

        onInput(e) {
            this.singleLineTextNew = e.target.innerText;
        },
    },
};
</script>
